import { gql } from '@apollo/client';

const getSqlPipeline = (sqlPipelineUri: string) => {
    return {
        variables: {
            sqlPipelineUri,
        },
        query: gql`
            query GetSqlPipeline($sqlPipelineUri: String!) {
                getSqlPipeline(sqlPipelineUri: $sqlPipelineUri) {
                    sqlPipelineUri
                    created
                    userRoleForPipeline
                    pipelineStageOptions
                    repo
                    label
                    stack {
                        resources
                        status
                        stackUri
                        region
                        accountid
                        link
                        stack
                        stackid
                    }
                    environment {
                        environmentUri
                        AwsAccountId
                        region
                    }
                    runs {
                        Id
                        StartedOn
                        JobRunState
                    }
                }
            }
        `,
    };
};

export default getSqlPipeline;
